'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReadMore = exports.CLASS_CONTENT_OPEN = exports.READ_MORE_TOGGLE = exports.READ_MORE_CONTAINER = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Selectors
var READ_MORE_CONTAINER = exports.READ_MORE_CONTAINER = '[data-read-more-container]'; /*
                                                                                       *  Read More
                                                                                       *    Script to add a class 'is-open' to a data-read-more container.
                                                                                       *    Use CSS to style change your state changes.
                                                                                       *
                                                                                       *  Version:
                                                                                       *    1.0.0 - 2020/04/23
                                                                                       */

var READ_MORE_TOGGLE = exports.READ_MORE_TOGGLE = '[data-read-more-toggle]';

//Classes
var CLASS_CONTENT_OPEN = exports.CLASS_CONTENT_OPEN = 'is-open';

var ReadMore = exports.ReadMore = function () {
  function ReadMore(container) {
    var _this = this;

    (0, _classCallCheck3.default)(this, ReadMore);

    this.container = container;

    container.on('click touchstart', READ_MORE_TOGGLE, function (e) {
      return _this.onReadMoreToggle(e);
    });
  }

  (0, _createClass3.default)(ReadMore, [{
    key: 'onReadMoreToggle',
    value: function onReadMoreToggle(e) {
      e.preventDefault(), e.stopPropagation();

      //Check state and add or remove class.
      this.container.toggleClass(CLASS_CONTENT_OPEN);
    }
  }]);
  return ReadMore;
}();

(0, _jquery2.default)(document).ready((0, _jquery2.default)(READ_MORE_CONTAINER).each(function (e, i) {
  return new ReadMore((0, _jquery2.default)(i));
}));